export const PathConstants = {
  HOME: "/",
  COMICS: "/comics",
  UPDATE: "/update",
} as const
